<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
         <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('companies.created_at_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.from')}}
                        <el-form-item prop="fechaAltaDesde">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaAltaDesde.value"
                            :picker-options="dateRangeOptions"
                            type="date"
                            format="dd-MM-yyyy"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaAltaD"
                            @blur="onBlurDatePickerMixin('.datePickerFechaAltaD-popover')"
                            @focus="onFocusDatePickerMixin('.datePickerFechaAltaD-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaAltaD-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.to')}}
                        <el-form-item prop="fechaAltaHasta">
                          <el-date-picker
                            class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaAltaHasta.value"
                            type="date"
                            format="dd-MM-yyyy"
                            :picker-options="dateRangeOptions"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaAltaD"
                            @blur="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @focus="onFocusDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaAltaH-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  id-prefix="companiesfilter"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="companies-filter-cif-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}</span>
              <el-form-item prop="cif">
                <el-input
                  class="w-full"
                  v-model="form.cif.value"
                  maxlength="50"
                  aria-labelledby="companies-filter-cif-label"
                >
                  <template v-if="form.cif.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de CIF"
                      @clear="form.cif.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="companies-filter-name-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.companyName')}}</span>
              <el-form-item prop="name">
                <el-input
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="150"
                  aria-labelledby="companies-filter-name-label"
                >
                  <template v-if="form.cif.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de CIF"
                      @clear="form.cif.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.automatic_download.value"
                prop="automatic_download"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.automatic_download')}}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.send_alerts.value"
                prop="send_alerts"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.send_alerts')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.estado.value"
                prop="estado"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.codPGN.value"
                prop="sede"
                :options="sedesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('app.location_link')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.nombreAgrupacion.value"
                prop="nombreAgrupacion"
                :options="listGroupingForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('app.single_grouping')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.certAsociado.value"
                prop="certAsociado"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.cert_asociado')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.alertaEmpresaDesactivada.value"
                prop="alertaEmpresaDesactivada"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.alertaEmpresaDesactivada')}}</template>
              </AccessibleElSelect>
            </div>

             <div v-if="hasPermVacacionesAEAT">
              <AccessibleElSelect
                v-model="form.consultaDiasCortesiaAEATError.value"
                prop="consultaDiasCortesiaAEATError"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.status_query_coutersy_days_error')}}</template>
              </AccessibleElSelect>
            </div>

             <div v-if="hasPermVacacionesAEAT">
              <AccessibleElSelect
                v-model="form.estadoDiasCortesiaAEATError.value"
                prop="estadoDiasCortesiaAEATError"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.status_solicitud_coutersy_days_error')}}</template>
              </AccessibleElSelect>
            </div>

             <div v-if="hasModuleHotFolder">
              <AccessibleElSelect
                v-model="form.errorHotfolder.value"
                prop="errorHotfolder"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.errorHotfolder')}}</template>
              </AccessibleElSelect>
            </div>

             <div v-if="hasModuleHotFolder">
              <AccessibleElSelect
                v-model="form.sinVigilarHotfolder.value"
                prop="sinVigilarHotfolder"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.sinVigilarHotfolder')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="companies-filter-email-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}</span>
              <el-form-item prop="email">
                <el-input
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="500"
                  aria-labelledby="companies-filter-email-label"
                >
                  <template v-if="form.email.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de email"
                      @clear="form.email.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div v-if="hasPermModuleSMS">
              <span id="companies-filter-phone-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.phone')}}</span>
              <el-form-item prop="phone">
                <el-input
                  class="w-full"
                  v-model="form.phone.value"
                  maxlength="9"
                  aria-labelledby="companies-filter-phone-label"
                >
                  <template v-if="form.phone.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de teléfono"
                      @clear="form.phone.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            
            <div v-if="hasModuleNotificacionesTerceros">
              <AccessibleElSelect
                v-model="form.conPoderesDelegados.value"
                prop="conPoderesDelegados"
                :options="valuesForAccessibleSelect"
                id-prefix="companiesfilter"
              >
                <template slot="label">{{$t('companies.dont_alert_delegated')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
import { i18n } from '@/i18n'
import moment from 'moment'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getLocations } from '@/services/app/getLocations'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { getAgrupacionesNombreCompanies } from '@/services/configurations/grouping/getAgrupacionesNombreCompanies'

import { ESTADOS_DIAS_CORTESIA } from '@/config/estados-dias-cortesia'

// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'companies',
      isOpen: this.panelOpen,
      form: {
        cif: { label: 'CIF', value: '' },
        name: { label: 'Razón social', value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        send_alerts: { label: 'Enviar avisos', value: '' },
        fechaAltaDesde: { label: 'F. alta desde', value: '' },
        fechaAltaHasta: { label: 'F. alta hasta', value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },        
        phone: { label: i18n.t('configurations.phone'), value: '' },
        estado: { label: i18n.t('companies.active'), value: '' },
        estadoDiasCortesiaAEATError: { label: i18n.t('companies.status_solicitud_coutersy_days_error'), value: '' },
        consultaDiasCortesiaAEATError: { label: i18n.t('companies.status_query_coutersy_days_error'), value: '' },
        alertaEmpresaDesactivada: { label: i18n.t('companies.alertaEmpresaDesactivada'), value: '' },
        certAsociado: { label: i18n.t('companies.cert_asociado'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
        codPGN: { label: i18n.t('app.location_link'), value: '' },
        errorHotfolder: { label: i18n.t('companies.errorHotfolder'), value: '' },
        sinVigilarHotfolder: { label: i18n.t('companies.sinVigilarHotfolder'), value: '' },
        conPoderesDelegados: { label: i18n.t('companies.dont_alert_delegated'), value: '' },
      },
      listGrouping: [],
      distribuidores: [],
      clientes: [],
      estadosDiasCortesia: ESTADOS_DIAS_CORTESIA,
      sedes: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  mounted: async function () {
    this.sedes = []
    let locs
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      locs = await getLocations()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
      
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    } else {
      locs = await getSedesByEmpresa()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
    }
    if (!locs.blnError) {
      locs.PGNS.forEach(row => {
        this.sedes.push({ id: row.IdPGN, label: row.Nombre, value: row.Codigo })
      })
    }

    const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    if (dataAgrupaciones.blnError === true) {
      this.doFeedback(dataAgrupaciones.msgError + ' [Código de error: ' + dataAgrupaciones.codError + ']')
    }
    this.listGrouping = dataAgrupaciones.Respuesta
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPermVacacionesAEAT () {
      return this.$store.getters['auth/hasModuleVacacionesAEAT']
    },
    hasModuleNotificacionesTerceros () {
      return this.$store.getters['auth/hasModuleNotificacionesTerceros'] 
    },
    hasModuleHotFolder () {
      return this.$store.getters['auth/hasModuleHotFolder']
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS'] &&
       (this.role === 'Administrador' || this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    // Computed properties para AccessibleElSelect
    distribuidoresForAccessibleSelect () {
      return this.distribuidores.map(dist => ({ id: dist.Nombre, name: dist.Nombre }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({ id: cliente.Nombre, name: cliente.Nombre }))
    },
    valuesForAccessibleSelect () {
      return this.values.map(item => ({ id: item.value, name: item.label }))
    },
    sedesForAccessibleSelect () {
      return this.sedes.map(sede => ({ id: sede.value, name: sede.label }))
    },
    listGroupingForAccessibleSelect () {
      return this.listGrouping.map(item => ({ id: item, name: item }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.cif.value = _temp.cif !== undefined && _temp.cif ? _temp.cif.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name ? _temp.name.value : ''
        this.form.automatic_download.value = _temp.automatic_download !== undefined && _temp.automatic_download ? _temp.automatic_download.value : ''
        this.form.fechaAltaDesde.value = _temp.fechaAltaDesde !== undefined && _temp.fechaAltaDesde ? _temp.fechaAltaDesde.value : ''
        this.form.fechaAltaHasta.value = _temp.fechaAltaHasta !== undefined && _temp.fechaAltaHasta ? _temp.fechaAltaHasta.value : ''
        this.form.send_alerts.value = _temp.send_alerts !== undefined && _temp.send_alerts ? _temp.send_alerts.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.estado.value = _temp.estado !== undefined && _temp.estado.value !== '' ? _temp.estado.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.phone.value = _temp.phone !== undefined && _temp.phone.value !== '' ? _temp.phone.value : ''
        this.form.conPoderesDelegados.value = _temp.conPoderesDelegados !== undefined && _temp.conPoderesDelegados.value !== '' ? _temp.conPoderesDelegados.value : ''
        this.form.estadoDiasCortesiaAEATError.value = _temp.estadoDiasCortesiaAEATError !== undefined && _temp.estadoDiasCortesiaAEATError.value !== '' ? _temp.estadoDiasCortesiaAEATError.value : ''
        this.form.consultaDiasCortesiaAEATError.value = _temp.consultaDiasCortesiaAEATError !== undefined && _temp.consultaDiasCortesiaAEATError.value !== '' ? _temp.consultaDiasCortesiaAEATError.value : ''
        this.form.alertaEmpresaDesactivada.value = _temp.alertaEmpresaDesactivada !== undefined && _temp.alertaEmpresaDesactivada.value !== '' ? _temp.alertaEmpresaDesactivada.value : ''
        this.form.certAsociado.value = _temp.certAsociado !== undefined && _temp.certAsociado.value !== '' ? _temp.certAsociado.value : ''
        this.form.nombreAgrupacion.value = _temp.nombreAgrupacion !== undefined && _temp.nombreAgrupacion.value !== '' ? _temp.nombreAgrupacion.value : ''
        this.form.codPGN.value = _temp.codPGN !== undefined && _temp.codPGN.value !== '' ? _temp.codPGN.value : ''
        this.form.errorHotfolder.value = _temp.errorHotfolder !== undefined && _temp.errorHotfolder.value !== '' ? _temp.errorHotfolder.value : ''
        this.form.sinVigilarHotfolder.value = _temp.sinVigilarHotfolder !== undefined && _temp.sinVigilarHotfolder.value !== '' ? _temp.sinVigilarHotfolder.value : ''
      }
      // console.log('_temp =>', _temp)
      // console.log('form =>', this.form)
    },
    watchFormHandler: function ({ fechaAltaDesde, fechaAltaHasta, send_alerts, automatic_download, estado, certAsociado }) {
      if (fechaAltaDesde.value !== undefined && moment(fechaAltaDesde.value).isValid()) {
        this.form.fechaAltaDesde.value = moment(fechaAltaDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaAltaDesde.value = ''
      }

      if (fechaAltaHasta.value !== undefined && moment(fechaAltaHasta.value).isValid()) {
        this.form.fechaAltaHasta.value = moment(fechaAltaHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaAltaHasta.value = ''
      }

      // if (fechaBajaDesde.value !== undefined && moment(fechaBajaDesde.value).isValid()) {
      //   this.form.fechaBajaDesde.value = moment(fechaBajaDesde.value).format('YYYY-MM-DD[T00:00:00]')
      // } else {
      //   this.form.fechaBajaDesde.value = ''
      // }

      // if (fechaBajaHasta.value !== undefined && moment(fechaBajaHasta.value).isValid()) {
      //   this.form.fechaBajaHasta.value = moment(fechaBajaHasta.value).format('YYYY-MM-DD[T23:59:59]')
      // } else {
      //   this.form.fechaBajaHasta.value = ''
      // }

      if (automatic_download !== undefined && automatic_download.value) {
        this.form.automatic_download.value = !!automatic_download.value
      }
      if (send_alerts !== undefined && send_alerts.value) {
        this.form.send_alerts.value = !!send_alerts.value
      }
      if (estado !== undefined && estado.value) {
        this.form.estado.value = !!estado.value
      }
      if (certAsociado !== undefined && certAsociado.value) {
        this.form.certAsociado.value = !!certAsociado.value
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        cif: { label: 'CIF', value: '' },
        name: { label: 'Razón social', value: '' },
        automatic_download: { label: 'Descarga automática', value: '' },
        send_alerts: { label: 'Enviar avisos', value: '' },
        fechaAltaDesde: { label: 'F. alta desde', value: '' },
        fechaAltaHasta: { label: 'F. alta hasta', value: '' },
        estado: { label: i18n.t('companies.active'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        phone: { label: i18n.t('configurations.phone'), value: '' },
        conPoderesDelegados: { label: i18n.t('companies.dont_alert_delegated'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        consultaDiasCortesiaAEATError: { label: i18n.t('companies.status_query_coutersy_days_error'), value: '' },
        estadoDiasCortesiaAEATError: { label: i18n.t('companies.status_solicitud_coutersy_days_error'), value: '' },
        alertaEmpresaDesactivada: { label: i18n.t('companies.alertaEmpresaDesactivada'), value: '' },
        certAsociado: { label: i18n.t('companies.cert_asociado'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
        codPGN: { label: i18n.t('app.location_link'), value: '' },
        errorHotfolder: { label: i18n.t('companies.errorHotfolder'), value: '' },
        sinVigilarHotfolder: { label: i18n.t('companies.sinVigilarHotfolder'), value: '' },
      }
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    }
  }
}
</script>
